// We can have a different item for all the actions
// SHARE, OFFER, HIRE etc. Using one now to keep it simple, because was pass the JobAssignmentStatus
export enum UpdateWorkerActions {
  UPDATE = 'UPDATE',
  UPDATING = 'UPDATING',
  UPDATED = 'UPDATED',
  UPDATE_FAILED = 'UPDATE_FAILED',
}
